import dayjs from 'dayjs'
import { cookie } from './cookie'
import { uuid } from '@zto/zpage'
import { COOKIE_CODES } from '../consts'

/** 埋点统计 */
export async function reportTraceData(app: any, { event_code, event_data }: any) {
  const router = app.router
  const { userStore } = app.stores

  let { path, label, name: menuCode, bizId } = router.currentRoute.value.meta

  const portalRoleCode = app?.userBasicInfo?.portalRoleCode ?? ''

  const userInfo = {
    ...userStore.data.basic
    // tuxi-operate-web
    // manageDistrictIds: [],
    // miniMenuTree: [],
    // permissionCommonValues: [],
    // permissionPcValues: [],
    // permissionWxValues: [],
    // // boss-operate-web
    // appMenuTree: [],
    // appPermissionValues: [],
    // pcMenuTree: [],
    // pcPermissionValues: []
  }

  // 数组太长了，zcat会一直pending，且数组信息不重要，故删掉
  for (let key in userInfo) {
    let item = userInfo[key]
    if (item && Array.isArray(item)) {
      delete userInfo[key]
    }
  }

  // const EventData = {
  //   pagePath: path, // 当前页面的路由
  //   pageTitle: label, // 当前页面标题
  //   userAgent: navigator.userAgent, // 浏览器类型
  //   // userInfo, // 登录用户，岗位组织和角色 // 下面map中，已经单独传了userInfo，故注释掉，不需要再传了
  //   ...event_data, // 额外参数
  //   action: event_data.action ? JSON.parse(JSON.stringify(event_data.action)) : '' // proxy，会引起zcat报错，故序列化
  // }

  // 上报用户信息及map
  window.zcat?.setUserInfo({
    userId: userInfo.accountCode || userInfo.currUserCode,
    userName: userInfo.account || userInfo.currUserMobile,
    map: JSON.parse(JSON.stringify({ ...userInfo }))
  })

  let name = ''
  let tag1 = ''
  let tag2 = ''
  let tag3 = ''
  if (event_code === 'query') {
    name = `${label}-查询-${event_data.action.url || event_data.action?.api?.url || ''}`
    tag1 = label
    tag2 = '查询'
    tag3 = event_data.action.url || event_data.action?.api?.url || ''
  } else if (event_code === 'export') {
    name = `${label}-导出全部-${event_data.params.exportType || ''}`
    tag1 = label
    tag2 = '导出全部'
    tag3 = event_data.params.exportType || ''
  } else if (event_code === 'action') {
    name = `${label}-${event_data.buttonLabel}-点击`
    tag1 = label
    tag2 = event_data.buttonLabel
    tag3 = '点击'
  } else if (event_code === 'pageIn') {
    name = `${event_data.to.meta.label}-进入`
    tag1 = event_data.to.meta.label
    tag2 = '进入'
    tag3 = event_data.to.path
  } else if (event_code === 'pageOut') {
    name = `${event_data.from.meta.label}-离开`
    tag1 = event_data.from.meta.label
    tag2 = '离开'
    tag3 = event_data.from.path
  }
  // 自定义上报指标，支持附加字段
  window.zcat?.trackEvent(name, tag1, tag2, tag3)

  // 大数据埋点----start
  let eventType = 'action' // action | page
  let eventCode = ''
  let pageInTime = ''
  let pageOutTime = ''

  if (event_code === 'query') {
    eventCode = `查询-${event_data.action.url || event_data.action?.api?.url || ''}`
  } else if (event_code === 'export') {
    eventCode = `导出全部-${event_data.params.exportType || ''}`
  } else if (event_code === 'action') {
    eventCode = `点击-${event_data.buttonLabel}`
  } else if (event_code === 'pageIn') {
    eventType = 'page'
    eventCode = 'pageIn'
    pageInTime = new Date().getTime() + ''
    path = event_data.to.path
  } else if (event_code === 'pageOut') {
    eventType = 'page'
    eventCode = 'pageOut'
    pageOutTime = new Date().getTime() + ''
    path = event_data.from.path
  }

  // console.log({
  //   eventGroup: 'tuxi-operate-web', // 事件分组
  //   eventCode, // 事件code query、export、action、route、pageIn、pageOut
  //   eventType, // 事件type page action
  //   pageId: path, // 页面id  取当前路由
  //   linkId: getLinkId(), // 链路id 登录成功就生成一个唯一id，再登录算下一次链路
  //   pageInTime, // 页面进入时间
  //   pageOutTime, // 页面离开时间
  //   deviceId: getDeviceId() // 设备id 存储到cookie、storage，尽量保持不变
  // });

  await app.api.addEventTracking({
    eventGroup: 'tuxi-operate-web', // 事件分组
    eventCode, // 事件code query、export、action、route、pageIn、pageOut
    eventType, // 事件type page action
    pageId: path, // 页面id  取当前路由
    menuCode, // 菜单code
    // bizId, // 菜单bizId 唯一值
    menuBizId: bizId, // 菜单bizId 唯一值
    portalRoleCode, // 门户code
    linkId: getLinkId(), // 链路id 登录成功就生成一个唯一id，再登录算下一次链路
    pageInTime, // 页面进入时间
    pageOutTime, // 页面离开时间
    deviceId: getDeviceId() // 设备id 存储到cookie、storage，尽量保持不变
  })

  // 大数据埋点----end
}

export function getLinkId() {
  /** 为方式linkId登出时清空，这里将设备id同时放入cookie和localStorage */
  const cId = cookie.get(COOKIE_CODES.LINK_ID)
  const lsId = localStorage.getItem(COOKIE_CODES.LINK_ID)

  let linkId = cId || lsId
  if (!linkId) linkId = uuid()

  if (!cId) cookie.set(COOKIE_CODES.LINK_ID, linkId)
  if (!lsId) localStorage.setItem(COOKIE_CODES.LINK_ID, linkId)

  return linkId
}

export function getDeviceId() {
  /** 为方式deviceId登出时清空，这里将设备id同时放入cookie和localStorage */
  const cId = cookie.get(COOKIE_CODES.DEVICE_ID)
  const lsId = localStorage.getItem(COOKIE_CODES.DEVICE_ID)

  let deviceId = cId || lsId
  if (!deviceId) deviceId = uuid()

  if (!cId) cookie.set(COOKIE_CODES.DEVICE_ID, deviceId)
  if (!lsId) localStorage.setItem(COOKIE_CODES.DEVICE_ID, deviceId)

  return deviceId
}
